import { useEffect, useState } from "react";
import Pagination from "../../../../components/Pagination";
import api from "../../../../api/api";
import * as bootstrap from "bootstrap";
import "../../Common/form.css";
import Button from "../../../../components/Button";
import InputField from "../../../../components/InputField";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { useNavigate } from "react-router-dom";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";

const ClientMaster = () => {
  const navigate = useNavigate();
  const [clientmasters, setClientmasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedUser, setSelectedUser] = useState(null);
  const [modalType, setModalType] = useState(null);

  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(clientmasters, 5);

  useEffect(() => {
    const fetchClientmaster = async () => {
      setLoading(true);
      try {
        const response = await api.get("/master-data/client-master");
        setClientmasters(response.data.users || []);
      } catch (error) {
        setError("Failed to fetch clientmaster");
        console.error("Failed to fetch clientmaster", error);
      } finally {
        setLoading(false);
      }
    };

    fetchClientmaster();
  }, []);
  console.log("selectedUser", selectedUser);
  const handleSubmit = async () => {
    try {
      if (!selectedUser || !selectedUser.user_id) {
        return;
      }
      console.log("Saving user:", selectedUser);
      console.log("User ID type:", typeof selectedUser.user_id);

      const response = await api.put(
        `/master-data/client-master/${selectedUser.user_id}`,
        {
          full_name: selectedUser.full_name,
          email: selectedUser.email,
          company_name: selectedUser.company_name,
          phone_number: selectedUser.phone_number,
        }
      );

      setClientmasters((prev) =>
        prev.map((user) =>
          user.user_id === selectedUser.user_id ? selectedUser : user
        )
      );

      handleCloseModal();
    } catch (err) {
      console.error("Error updating client:", err);
    }
  };

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [clientmasters, currentPage]);

  const handleOpenModal = (user, type) => {
    setSelectedUser(user);
    setModalType(type);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
    setModalType(null);
  };

  const handleConfirmDelete = async () => {
    try {
      await api.delete(`/master-data/client-master/${selectedUser.user_id}`);
      setClientmasters((prev) =>
        prev.filter((u) => u.user_id !== selectedUser.user_id)
      );
      handleCloseModal();
    } catch (err) {
      console.error("Failed to delete user", err);
      alert("Error deleting user");
    }
  };

  if (error) return <p className="text-danger">{error}</p>;
  const columns = [
    { label: "User ID", accessor: "user_id" },
    {
      label: "Name",
      accessor: "full_name",
    },
    { label: "Email", accessor: "email" },
    { label: "Phone Number", accessor: "phone_number" },
    { label: "Company", accessor: "company_name" },
    {
      label: "Documents",
      render: (row) => (
        <>
          <span
            style={{
              color: "#0077ffff",
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: "500",
            }}
            onClick={() => navigate(`/user-documents/${row.user_id}`)}
          >
            View
          </span>
        </>
      ),
    },
    {
      label: "Action",
      render: (row) => (
        <>
          <EditIcon
            onClick={() => handleOpenModal(row, "edit")}
            style={{ cursor: "pointer", color: "#1e305e" }}
          />
          <DeleteIcon
            onClick={() => handleOpenModal(row, "delete")}
            style={{ cursor: "pointer", color: "#1e305e" }}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Breadcrumbs />
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No ClientMaster found."
         itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />

      {selectedUser && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {modalType === "edit" ? "Edit User" : "Confirm Delete"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>

              <div className="modal-body">
                {modalType === "edit" ? (
                  <form>
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <InputField
                        value={selectedUser.full_name}
                        onChange={(e) =>
                          setSelectedUser({
                            ...selectedUser,
                            full_name: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <InputField
                        type="email"
                        value={selectedUser.email}
                        onChange={(e) =>
                          setSelectedUser({
                            ...selectedUser,
                            email: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Company Name</label>
                      <InputField
                        value={selectedUser.company_name}
                        onChange={(e) =>
                          setSelectedUser({
                            ...selectedUser,
                            company_name: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <InputField
                        value={selectedUser.phone_number}
                        type="number"
                        onChange={(e) =>
                          setSelectedUser({
                            ...selectedUser,
                            phone_number: e.target.value,
                          })
                        }
                      />
                    </div>
                  </form>
                ) : (
                  <div className="text-center">
                    <p>Are you sure you want to delete this user?</p>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>

                {modalType === "delete" ? (
                  <Button
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                    text="Confirm"
                  />
                ) : (
                  <Button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    text="submit"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ClientMaster;
